/**
 * External links constants used throughout the application
 */
export const EXTERNAL_LINKS = {
  ISSUE_REPORT:
    'https://synply.atlassian.net/servicedesk/customer/portal/36/create/192',
} as const;
